<template>
  <div class="login">
    <div class="left">
      <h3>湖北佳成集团企业管理系统<span>1.0</span></h3>
      <p>
        Hubei Jiacheng Group Management System
        <span>1.0</span>
      </p>
    </div>
    <div class="right">
      <div class="title">欢迎登录</div>
      <div class="tabs">
        <div
          class="item"
          :class="{ active: item.value == loginForm.userType }"
          @click="loginForm.userType = item.value"
          v-for="item of userTypes"
          :key="item.value"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
      <div class="current-bar">
          <div class="cur" :class="'cur_' + loginForm.userType"></div>
      </div>
      <div class="form">
        <div class="form-item">
          <input
            v-model="loginForm.username"
            type="text"
            class="form-item__input"
            auto-complete="off"
            placeholder="请输入您的账号"
          />
        </div>
        <div class="form-item">
          <input
            v-model="loginForm.password"
            type="password"
            class="form-item__input"
            auto-complete="off"
            placeholder="请输入您的密码"
          />
        </div>
        <div class="form-bottom">
          <div
            class="remember-password"
            @click="loginForm.rememberMe = !loginForm.rememberMe"
          >
            <div class="checkbox" :class="{ active: loginForm.rememberMe }">
              <svg
                t="1687197745159"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="13739"
                width="64"
                height="64"
              >
                <path
                  d="M448.64 855.68L64 471.04l135.68-135.68 248.96 248.96 386.08-386.08 135.68 135.84-521.76 521.6z"
                  p-id="13740"
                ></path>
              </svg>
            </div>
            记住密码
          </div>
          <div class="btn-submit" @click="handleLogin">
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
            <svg
              t="1687198409730"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="16886"
              width="64"
              height="64"
            >
              <path
                d="M779.8 240.9l225.9 225.9c25 25 25 65.5 0 90.5L779.8 783.1c-1.6 1.6-4.1 1.6-5.7 0l-62.2-62.2c-1.6-1.6-1.6-4.1 0-5.7l148.4-148.4c2.5-2.5 0.7-6.8-2.8-6.8H4c-2.2 0-4-1.8-4-4v-88c0-2.2 1.8-4 4-4h853.5c3.6 0 5.3-4.3 2.8-6.8L711.9 308.8c-1.6-1.6-1.6-4.1 0-5.7l62.2-62.2c1.6-1.6 4.1-1.6 5.7 0z"
                p-id="16887"
              ></path>
            </svg>
          </div>
        </div>
          <!-- <el-button type="primary" plain @click="handlePrint">打印准考证</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import { validateIDCardISO } from "@/utilsCloud/validate";
import { empAdmissionTicket} from '@/apiCloud/login'
export default {
  data() {
    return {
      codeUrl: "",
      cookiePassword: "",
      userTypes: [
        { value: "05", label: "用户登录" },
        { value: "08", label: "企业登录" },
      ],
      loginForm: {
        username: "",
        password: "",
        userType: "05",
        rememberMe: false,
        code: "",
        uuid: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaOnOff: false,
      // 注册开关
      register: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.getCookie();
  },
  methods: {
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      const userType = Cookies.get("userType");
      this.loginForm = {
        userType: userType === undefined ? "05" : userType,
        username: username === undefined ? this.loginForm.username : username,
        password:
          password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
      };
    },
    canLogin() {
      if (this.loading) return;
      const { username, password } = this.loginForm;
      if (!username) {
        this.$message.error("请输入您的账号！");
        return false;
      }
      if (!password) {
        this.$message.error("请输入您的密码！");
        return false;
      }
      return true;
    },
    handleLogin() {
      if (this.canLogin()) {
        this.loading = true;
        if (this.loginForm.rememberMe) {
          Cookies.set("username", this.loginForm.username, { expires: 30 });
          Cookies.set("password", encrypt(this.loginForm.password), {
            expires: 30,
          });
          Cookies.set("rememberMe", this.loginForm.rememberMe, {
            expires: 30,
          });
          Cookies.set("userType", this.loginForm.userType, { expires: 30 });
        } else {
          Cookies.remove("username");
          Cookies.remove("password");
          Cookies.remove("rememberMe");
          Cookies.remove("userType");
        }
        const data = {
          entpId: localStorage.getItem("enterpriseId"),
          ...this.loginForm,
        };
        this.$store
          .dispatch("Login", data)
          .then(() => {
            // this.$router.push({ path: this.redirect || "/" }).catch(() => {});
            if (this.loginForm.userType == "05") {
              this.$router.push({ path: "/" }).catch(() => {});
            } else {
              const eUrl = window.location.href;
              window.location.href =
                eUrl.substring(0, eUrl.indexOf("/", 8)) + "/admin/index";
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    handlePrint(){
      const { username:idCard } = this.loginForm
      if(!idCard){
        return this.$message.error('请输入身份证')
      }
      if(!validateIDCardISO(idCard)){
        return this.$message.error('请输入正确的身份证')
      }
      empAdmissionTicket({idCard}).then()
    }
  },
};
</script>

<style lang="less" scoped>
@login-them: #0071fb;
.login {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #fff url("~@/assets/images/login-bg1.0.png") no-repeat center
    bottom;
  background-size: cover;
  .left {
    width: 610px;
    height: 680px;
    padding-top: 100px;
    color: #fff;
    h3 {
      font-weight: bold;
      font-size: 64px;
      line-height: 100px;
      letter-spacing: 8px;
      margin: 0;
      span {
        padding-left: 20px;
      }
    }
    p {
      letter-spacing: 1px;
      font-size: 18px;
      white-space: nowrap;
      margin-top: 40px;
    }
  }
  .right {
    width: 560px;
    height: 680px;
    margin-left: 60px;
    padding: 60px 48px 10px 48px;
    background: #ffffff;
    box-shadow: 0px 8px 10px 0px rgba(52, 130, 255, 0.15);
    border-radius: 32px;
    .title {
      position: relative;
      padding-bottom: 24px;
      font-size: 48px;
      font-weight: bold;
      color: @login-them;
      // &:after {
      //   content: "";
      //   position: absolute;
      //   left: 0;
      //   bottom: 0;
      //   width: 88px;
      //   height: 4px;
      //   background: @login-them;
      // }
    }

    .tabs {
      justify-content: space-between;
      margin-top: 20px;
      .item {
        display: inline-block;
        margin-right: 40px;
        font-size: 26px;
        color: #666666;
        cursor: pointer;

        &:hover {
          color: #256de3;
        }

        &.active {
          color: #256de3;
          font-weight: bold;
        }
      }
    }
    .current-bar {
          position: relative;
          width: 100%;
          height: 4px;
          background: #f4f4f4;
          margin-top: 16px;
          .cur {
            position: absolute;
            left: 0;
            top: 0;
            width: 102px;
            height: 100%;
            background: #256de3;
            transition: all 0.3s;

            &.cur_05 {
              left: 0;
            }
            &.cur_08 {
              left: 150px;
            }
          }
        }
  }

  .form {
    margin-top: 40px;
    &-item {
      margin-bottom: 40px;
      &__input {
        width: 100%;
        height: 72px;
        background: #ffffff;
        border: 2px solid #f2f2f6;
        border-radius: 6px;
        font-size: 20px;
        padding-left: 28px;
        outline: none;
      }
    }
    &-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .remember-password {
        font-size: 20px;
        color: #666666;
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
        .checkbox {
          width: 24px;
          height: 24px;
          background: #fff;
          border: 2px solid @login-them;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          &.active {
            background: @login-them;
          }
          svg {
            width: 24px;
            font-weight: bold;
            fill: #fff;
          }
          margin-right: 12px;
        }
      }
      .btn-submit {
        width: 235px;
        height: 72px;
        background: @login-them;
        border-radius: 6px;
        font-weight: bold;
        color: #fff;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 50px;
        cursor: pointer;
        svg {
          position: relative;
          left: 0;
          fill: #fff;
          width: 30px;
          transition: all 0.2s;
        }
        &:hover {
          svg {
            left: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login_v1.vue